<script>
    import { onMount } from 'svelte';
    import * as d3 from 'd3';
    import { BASE_DATA_URL, HERD_IMMUNITY_PERCENT } from '../constants';
    import { buildCacheParam } from '../utils';
    import whenVaccinatedChart from '../charts/whenVaccinatedChart';

    let chartContainer;

    onMount(async () => {
        const timeParse = d3.timeParse('%Y-%m-%d');
        const data = await d3.csv(`${BASE_DATA_URL}/when-vaccinated.csv?d=${buildCacheParam()}`, d => {
          return {
            ...d,
            date: timeParse(d.date)
          }
        });
        const chart = whenVaccinatedChart().data(data);
        d3.select(chartContainer).call(chart);
    });
</script>

<div class="chart-outer">
    <h3>When will we be vaccinated?</h3>
    <p class="description">When {d3.format('.0%')(HERD_IMMUNITY_PERCENT)} of adults receive 2 doses based on the average rate of vaccinations for the last week</p>
    <div bind:this={chartContainer}/>
</div>
